define('wafilter', ['jquery', 'waoffcanvas'], function ($, waoffcanvas) {

  return {
    filterForm: $('.js_filter'),
    filterOpenButton: $('.js_filterOpen'),
    filterContainerOrg: $('#js_filterOriginal'),
    filterContainerSlide: $('#js_filterSlide'),
    filterRemoveButton: $('.js_filterRemove'),
    filterLabel: $('.makaira-filter__label'),
    filterButton: $('.makaira__filter--button'),
    filterButtonAll: $('.js_filterSubmitAll'),
    activeClassName: "js_active",

    openFilter: function openFilter() {
      this.filterContainerOrg.children().appendTo(this.filterContainerSlide);
      waoffcanvas.open('filter');
    },
    closeFilter: function closeFilter() {
      this.filterContainerSlide.children().appendTo(this.filterContainerOrg);
      waoffcanvas.close();
    },
    countFilter: function countFilter(e) {
      var el = $(e.currentTarget);
      var filterBox = el.closest('.makaira-filter__filter');
      var submitBtn = filterBox.find('.makaira__filter--button');
      var filterBoxCheckedCheckboxes = filterBox.find("[type='checkbox']:checked").length;
      var allCheckedCheckboxes = this.filterForm.find("[type='checkbox']:checked").length;
      var loadingSvg = this.filterButtonAll.find('svg use');

      if (allCheckedCheckboxes === 0) {
        this.filterButtonAll.removeClass(this.activeClassName);
        loadingSvg.attr('xlink:href', '#svg-loading');
      } else {
        this.filterButtonAll.addClass(this.activeClassName);
        loadingSvg.attr('xlink:href', '#svg-loading-white');
      }

      if (filterBoxCheckedCheckboxes === 0) {
        submitBtn.removeClass(this.activeClassName).find('svg use').attr('xlink:href', '#svg-loading');
      } else {
        submitBtn.addClass(this.activeClassName).find('svg use').attr('xlink:href', '#svg-loading-white');
      }
    },
    bindEvents: function bindEvents() {
      var _this = this;

      this.filterOpenButton.on('click', function (e) {
        _this.openFilter();
      });

      this.filterLabel.prev('input').on('change', function (e) {
        _this.countFilter(e);
      });

      this.filterRemoveButton.on('click', function (e) {
        var self = $(e.currentTarget);
        var labelID = self.data('for');
        console.log(labelID);
        //self.unbind('click') && $('#'+labelID).trigger('click').closest('form').submit();
        //td changes
        self.unbind('click') && $('#' + labelID).next('label').trigger('click');
      });

      $(window).resize(function () {
        if (window.wabreakpoint === 'large') _this.closeFilter();
      });
    },
    init: function init() {
      this.bindEvents();
    }
  };
});

